import {positionTopRight} from '../../../../shared-components/mixin/position';
import {Btn} from '../../button/btn-type/Btn';

// --- Card Conditions ---
// -----------------------
export const conditionDeletableCard = (deletable) => {
    if (deletable) {
        return `
            ${Btn} {
                ${positionTopRight()}
                transform: translate(8px, -8px);
            }
        `;
    }
};
